define('gc/modelHelpersOverride', function() {
  return {};
});
define('gc/locOverride', function() {
    return {};
});
define('gc/wizardConfigOverride', ['gc/abTest'], function(abTest) {
    var wizardConfigOverride = {
        lobs: [
            {id: "flight"},
            {id: "hotel"},
            {id: "flightHotel", label:"Package Deals", isPackage: true, defaultLob: true},
            {id: "car"},
            {id: "activity"},
            {id: "cruise"}
        ]
    };

    (function(){
        var defaultLOBId = "package";
        var abacusGROChangeDefaultLOBonHP = abTest.get(6864).value;
        if (abacusGROChangeDefaultLOBonHP == 1) {
            defaultLOBId = "flight";
        } else if (abacusGROChangeDefaultLOBonHP == 2) {
            defaultLOBId = "hotel"
        }
        for (i = 0; i < wizardConfigOverride.lobs.length; i++) {
            if (wizardConfigOverride.lobs[i].id == defaultLOBId) {
                wizardConfigOverride.lobs[i].defaultLob = true;
                break;
            }
        }

    })();

    return wizardConfigOverride;
});



define('gc/defaultConfigOverride', function() {
    return {
        model: {
            startTime: 720,
            endTime: 720,
            showCruiseOptions: false
        },
        viewRules: {
            allowFlightTabAddCarOption: function (model) {
                return false;
            }
        }
    };
});
define(['gc/carConfigOverride'], function() {
    return {
        model: {
            startTime: "1200PM",
            endTime: "1200PM"
        },
        carOptions: ['type', 'vendor', 'discount'],
        constraints: {
            carTypes: function (state, config) {
                return [
                    {key: "No preference", value: "1"},
                    {key: "Economy", value: "2"},
                    {key: "Compact", value: "5"},
                    {key: "Midsize", value: "3"},
                    {key: "Standard", value: "6"},
                    {key: "Fullsize", value: "4"},
                    {key: "Premium", value: "9"},
                    {key: "Luxury", value: "7"}
                ];
            }
        },
        carsSpecialEquipment: [
            ['infantseat', 'toddlerseat', 'navigation'],
            ['skirack', 'chains'],
            ['lefthand', 'righthand']
        ]
    };
});
define('gc/hotelConfigOverride', function() {
  return {};
});
define('gc/activityConfigOverride', function() {
  return {};
});
define('gc/packageConfigOverride', ['gc/loc'], function(loc) {
    return {
        viewRules: {
            enableAdvancedOptions: function (model) {
                'use strict';
                if (loc.masterconfig.switches.isCabinClassOptionEnabled) {
                    var flightHotel = model.get('packages.flight') && model.get('packages.hotel') && !model.get('packages.car') && !model.get('packages.train');

                    return flightHotel;
                }
                return false;
            },
            hideFlightOptions: function (model) {
                'use strict';
                return !model.get('showFlightOptions');
            },
            preferredClass: function (model) {
                return [
                    { name: loc.flight.preferredClassFirst, value: 'f'},
                    { name: loc.flight.preferredClassBusiness, value: 'b'},
                    { name: loc.flight.preferredClassEconomy, value: '', selected: 'selected'},
                    { name: loc.flight.preferredClassPremiumEconomy, value: 'p'}
                ];
            }
        }
    };
});


define('gc/cruiseConfigOverride', ['gc/defaultConfig', 'gc/getLob'], function(defaultConfig, getLob) {
    var cruiseLineShipMaps = {
        "1": [
            {name: "All Ships", value: "-99"},
            {name: "Breeze", value: "834"},
            {name: "Conquest", value: "191"},
            {name: "Dream", value: "604"},
            {name: "Ecstasy", value: "3"},
            {name: "Elation", value: "2"},
            {name: "Fantasy", value: "18"},
            {name: "Fascination", value: "11"},
            {name: "Freedom", value: "480"},
            {name: "Glory", value: "228"},
            {name: "Imagination", value: "19"},
            {name: "Inspiration", value: "26"},
            {name: "Legend", value: "192"},
            {name: "Liberty", value: "357"},
            {name: "Magic", value: "605"},
            {name: "Miracle", value: "284"},
            {name: "Paradise", value: "24"},
            {name: "Pride", value: "183"},
            {name: "Sensation", value: "10"},
            {name: "Splendor", value: "532"},
            {name: "Sunshine", value: "1019"},
            {name: "Triumph", value: "23"},
            {name: "Valor", value: "285"},
            {name: "Victory", value: "22"}
        ], "2": [
            {name: "All Ships", value: "-99"},
            {name: "Caribbean Princess", value: "315"},
            {name: "Coral Princess", value: "193"},
            {name: "Crown Princess", value: "422"},
            {name: "Dawn Princess", value: "17"},
            {name: "Diamond Princess", value: "248"},
            {name: "Emerald Princess", value: "485"},
            {name: "Golden Princess", value: "59"},
            {name: "Grand Princess", value: "63"},
            {name: "Island Princess", value: "247"},
            {name: "Ocean Princess", value: "590"},
            {name: "Pacific Princess", value: "13"},
            {name: "Royal Princess", value: "913"},
            {name: "Ruby Princess", value: "534"},
            {name: "Sapphire Princess", value: "299"},
            {name: "Sea Princess", value: "360"},
            {name: "Star Princess", value: "184"},
            {name: "Sun Princess", value: "67"}
        ], "4": [
            {name: "All Ships", value: "-99"},
            {name: "Adventure of the Seas", value: "79"},
            {name: "Allure of the Seas", value: "635"},
            {name: "Brilliance of the Seas", value: "187"},
            {name: "Enchantment of the Seas", value: "72"},
            {name: "Explorer of the Seas", value: "71"},
            {name: "Freedom of the Seas", value: "419"},
            {name: "Grandeur of the Seas", value: "70"},
            {name: "Independence of the Seas", value: "528"},
            {name: "Jewel of the Seas", value: "314"},
            {name: "Legend of the Seas", value: "82"},
            {name: "Liberty of the Seas", value: "490"},
            {name: "Majesty of the Seas", value: "16"},
            {name: "Mariner of the Seas", value: "278"},
            {name: "Navigator of the Seas", value: "195"},
            {name: "Oasis of the Seas", value: "607"},
            {name: "Radiance of the Seas", value: "78"},
            {name: "Rhapsody of the Seas", value: "76"},
            {name: "Serenade of the Seas", value: "279"},
            {name: "Splendour of the Seas", value: "74"},
            {name: "Vision of the Seas", value: "75"},
            {name: "Voyager of the Seas", value: "14"}
        ], "6": [
            {name: "All Ships", value: "-99"},
            {name: "Celebrity Century", value: "31"},
            {name: "Celebrity Constellation", value: "186"},
            {name: "Celebrity Eclipse", value: "606"},
            {name: "Celebrity Equinox", value: "578"},
            {name: "Celebrity Infinity", value: "34"},
            {name: "Celebrity Millennium", value: "36"},
            {name: "Celebrity Reflection", value: "927"},
            {name: "Celebrity Silhouette", value: "799"},
            {name: "Celebrity Solstice", value: "535"},
            {name: "Celebrity Summit", value: "37"},
            {name: "Celebrity Xpedition", value: "349"}
        ], "7": [
            {name: "All Ships", value: "-99"},
            {name: "Costa Classica", value: "44"},
            {name: "Costa Deliziosa", value: "690"},
            {name: "Costa Fascinosa", value: "922"},
            {name: "Costa Favolosa", value: "822"},
            {name: "Costa Fortuna", value: "286"},
            {name: "Costa Luminosa", value: "584"},
            {name: "Costa Magica", value: "287"},
            {name: "Costa Mediterranea", value: "280"},
            {name: "Costa neoRomantica", value: "977"},
            {name: "Costa Pacifica", value: "583"},
            {name: "Costa Serena", value: "500"},
            {name: "Costa Victoria", value: "41"},
            {name: "Costa Voyager", value: "987"}
        ], "8": [
            {name: "All Ships", value: "-99"},
            {name: "Breakaway", value: "968"},
            {name: "Dawn", value: "211"},
            {name: "Epic", value: "693"},
            {name: "Gem", value: "501"},
            {name: "Getaway", value: "969"},
            {name: "Jade", value: "531"},
            {name: "Jewel", value: "365"},
            {name: "Pearl", value: "482"},
            {name: "Sky", value: "94"},
            {name: "Spirit", value: "344"},
            {name: "Star", value: "176"},
            {name: "Sun", value: "96"},
            {name: "Pride of America", value: "298"}
        ], "9": [
            {name: "All Ships", value: "-99"},
            {name: "Dream", value: "776"},
            {name: "Fantasy", value: "869"},
            {name: "Magic", value: "47"},
            {name: "Wonder", value: "48"}
        ], "14": [
            {name: "All Ships", value: "-99"},
            {name: "Serenity", value: "275"},
            {name: "Symphony", value: "105"}
        ], "15": [
            {name: "All Ships", value: "-99"},
            {name: "Seven Seas Mariner", value: "146"},
            {name: "Seven Seas Navigator", value: "140"},
            {name: "Seven Seas Voyager", value: "255"}
        ], "17": [
            {name: "All Ships", value: "-99"},
            {name: "Silver Cloud", value: "147"},
            {name: "Silver Explorer", value: "581"},
            {name: "Silver Galapagos", value: "1108"},
            {name: "Silver Shadow", value: "149"},
            {name: "Silver Spirit", value: "634"},
            {name: "Silver Whisper", value: "150"},
            {name: "Silver Wind", value: "148"}
        ], "21": [
            {name: "All Ships", value: "-99"},
            {name: "Seabourn Legend", value: "85"},
            {name: "Seabourn Odyssey", value: "556"},
            {name: "Seabourn Pride", value: "84"},
            {name: "Seabourn Quest", value: "813"},
            {name: "Seabourn Sojourn", value: "689"},
            {name: "Seabourn Spirit", value: "103"}
        ], "24": [
            {name: "All Ships", value: "-99"},
            {name: "Wind Spirit", value: "129"},
            {name: "Wind Star", value: "130"},
            {name: "Wind Surf", value: "131"}
        ], "38": [
            {name: "All Ships", value: "-99"},
            {name: "M.V. Reef Endeavour", value: "197"},
            {name: "PS Murray Princess", value: "527"}
        ], "40": [
            {name: "All Ships", value: "-99"},
            {name: "SuperStar Virgo", value: "216"}
        ], "58": [
            {name: "All Ships", value: "-99"},
            {name: "Insignia", value: "297"},
            {name: "Marina", value: "688"},
            {name: "Nautica", value: "400"},
            {name: "Regatta", value: "296"},
            {name: "Riviera", value: "912"}
        ], "83": [
            {name: "All Ships", value: "-99"},
            {name: "MSC Armonia", value: "614"},
            {name: "MSC Divina", value: "953"},
            {name: "MSC Fantasia", value: "613"},
            {name: "MSC Magnifica", value: "685"},
            {name: "MSC Musica", value: "546"},
            {name: "MSC Opera", value: "548"},
            {name: "MSC Orchestra", value: "544"},
            {name: "MSC Poesia", value: "582"},
            {name: "MSC Preziosa", value: "1069"},
            {name: "MSC Sinfonia", value: "543"},
            {name: "MSC Splendida", value: "627"}
        ], "84": [
            {name: "All Ships", value: "-99"},
            {name: "Avalon Affinity", value: "575"},
            {name: "Avalon Angkor", value: "946"},
            {name: "Avalon Creativity", value: "576"},
            {name: "Avalon Felicity", value: "691"},
            {name: "Avalon Imagery", value: "541"},
            {name: "Avalon Luminary", value: "692"},
            {name: "Avalon Panorama", value: "826"},
            {name: "Avalon Scenery", value: "540"},
            {name: "Avalon Tranquility", value: "542"},
            {name: "Avalon Visionary", value: "942"},
            {name: "Avalon Vista", value: "944"},
            {name: "ms Mayfair", value: "948"}
        ], "90": [
            {name: "All Ships", value: "-99"},
            {name: "MV Orion", value: "401"}
        ], "104": [
            {name: "All Ships", value: "-99"},
            {name: "Pacific Dawn", value: "523"},
            {name: "Pacific Jewel", value: "654"},
            {name: "Pacific Pearl", value: "695"}
        ], "116": [
            {name: "All Ships", value: "-99"},
            {name: "Azamara Journey", value: "624"},
            {name: "Azamara Quest", value: "625"}
        ], "117": [
            {name: "All Ships", value: "-99"},
            {name: "Queen Elizabeth ", value: "687"},
            {name: "Queen Mary 2", value: "571"},
            {name: "Queen Victoria", value: "572"}
        ], "129": [
            {name: "All Ships", value: "-99"},
            {name: "RV Mekong Pandaw", value: "660"},
            {name: "RV Tonle Pandaw", value: "659"}
        ], "130": [
            {name: "All Ships", value: "-99"},
            {name: "Viking Bragi", value: "1038"},
            {name: "Viking Forseti", value: "1039"},
            {name: "Viking Helgi", value: "684"},
            {name: "Viking Idun", value: "919"},
            {name: "Viking Pride", value: "678"},
            {name: "Viking Rinda", value: "1040"},
            {name: "Viking Skadi", value: "1014"},
            {name: "Viking Tor", value: "1041"},
            {name: "Viking Truvor", value: "672"}
        ], "132": [
            {name: "All Ships", value: "-99"}
        ], "133": [
            {name: "All Ships", value: "-99"},
            {name: "Nieuw Amsterdam", value: "1045"},
            {name: "Oosterdam", value: "908"},
            {name: "Rotterdam", value: "1048"}
        ], "136": [
            {name: "All Ships", value: "-99"},
            {name: "Queen Isabel", value: "1050"},
            {name: "River Ambassador", value: "748"},
            {name: "River Baroness", value: "749"},
            {name: "River Beatrice", value: "750"},
            {name: "River Countess", value: "751"},
            {name: "River Duchess", value: "752"},
            {name: "River Empress", value: "753"},
            {name: "River Orchid", value: "1021"},
            {name: "River Princess", value: "754"},
            {name: "River Queen", value: "756"},
            {name: "River Royale", value: "755"},
            {name: "River Saigon", value: "930"},
            {name: "River Tosca", value: "759"},
            {name: "River Victoria", value: "858"},
            {name: "S.S. Antoinette", value: "857"}
        ], "139": [
            {name: "All Ships", value: "-99"},
            {name: "ms Amabella", value: "762"},
            {name: "ms Amacello", value: "766"},
            {name: "ms Amadagio", value: "768"},
            {name: "ms Amadante", value: "765"},
            {name: "ms Amakatarina", value: "862"},
            {name: "ms AmaLotus", value: "883"},
            {name: "ms Amalyra", value: "764"},
            {name: "ms Amaverde", value: "811"},
            {name: "MS Caledonian Sky", value: "1086"},
            {name: "Yangzi Explorer", value: "1073"}
        ], "155": [
            {name: "All Ships", value: "-99"},
            {name: "MS Expedition", value: "859"}
        ], "164": [
            {name: "All Ships", value: "-99"},
            {name: "Spirit", value: "906"},
            {name: "Legend", value: "1202"}
        ], "200": [
            {name: "All Ships", value: "-99"}
        ], "210": [
            {name: "All Ships", value: "-99"}
        ], "-99": [
            {name: "All Ships", value: "-99"}
        ]
    };

    var cruiseConfig = {
        calendar: {
            months: [ "January ", "February ", "March ", "April ", "May ", "June ",
                "July ", "August ", "September ", "October ", "November ", "December " ]
        },
        model: {
            'cruise-destination': "-99",
            'sailing-date': "",
            duration: '-99',
            'cruise-line': '-99',
            cobrand: '36087',
            webpagerecno: '5412',
            ship: '-99',
            'departure-port': '-99',
            'sort-by': '4',
            'sort-order': '1',
            'price-range': '-99',
            shipOptions: [
                {value: "", name: "All Ships"}
            ]
        },
        viewRules: {
            destinationOptions: function (model) {
                return [
                    {value: "-99", name: "All Destinations", selected: 'selected'},
                    {value: "1", name: "Africa"},
                    {value: "2", name: "Alaska"},
                    {value: "41", name: "Antarctic"},
                    {value: "136", name: "Arctic"},
                    {value: "37", name: "Asia"},
                    {value: "515", name: "Australia"},
                    {value: "3", name: "Australia/New Zealand"},
                    {value: "4", name: "Bahamas"},
                    {value: "5", name: "Bermuda"},
                    {value: "6", name: "Canada/New England"},
                    {value: "19", name: "Caribbean"},
                    {value: "7", name: "Caribbean, Eastern"},
                    {value: "21", name: "Caribbean, Exotic"},
                    {value: "8", name: "Caribbean, Southern"},
                    {value: "9", name: "Caribbean, Western"},
                    {value: "42", name: "Central America"},
                    {value: "54", name: "Europe"},
                    {value: "20", name: "Europe, Mediterranean"},
                    {value: "10", name: "Europe, Northern"},
                    {value: "73", name: "Europe, Western"},
                    {value: "11", name: "Far East"},
                    {value: "12", name: "Hawaii"},
                    {value: "158", name: "Japan"},
                    {value: "14", name: "Mexican Baja/Riviera"},
                    {value: "59", name: "Middle East"},
                    {value: "62", name: "New Zealand"},
                    {value: "25", name: "Nowhere"},
                    {value: "15", name: "Pacific Coastal"},
                    {value: "16", name: "Panama Canal"},
                    {value: "343", name: "River Cruise, Asia"},
                    {value: "255", name: "River Cruise, China"},
                    {value: "315", name: "River Cruise, Egypt"},
                    {value: "256", name: "River Cruise, Europe/Russia"},
                    {value: "17", name: "South America"},
                    {value: "36", name: "South Pacific"},
                    {value: "68", name: "Southeast Asia"},
                    {value: "18", name: "Transatlantic"},
                    {value: "39", name: "Transpacific"},
                    {value: "74", name: "World Cruise"}
                ];
            },

            durationOptions: function (model) {
                return [
                    {name: "Any Duration", value: "-99", selected: "selected"},
                    {name: "2-6 Nights", value: "1"},
                    {name: "7-9 Nights", value: "2"},
                    {name: "10-14 Nights", value: "3"},
                    {name: "Over 14 Nights", value: "4"}
                ];
            },

            cruiseLineOptions: function (model) {
                return [
                    {value: "-99", name: "All Cruise Lines", selected: "selected"},
                    {value: "139", name: "APT au"},
                    {value: "84", name: "Avalon Waterways au"},
                    {value: "116", name: "Azamara Club"},
                    {value: "38", name: "Captain Cook"},
                    {value: "1", name: "Carnival"},
                    {value: "164", name: "Carnival   au"},
                    {value: "6", name: "Celebrity"},
                    {value: "7", name: "Costa"},
                    {value: "132", name: "Costa   au"},
                    {value: "14", name: "Crystal"},
                    {value: "117", name: "Cunard au"},
                    {value: "9", name: "Disney"},
                    {value: "155", name: "G Adventures"},
                    {value: "133", name: "Holland America"},
                    {value: "210", name: "Lindblad Expeditions au"},
                    {value: "83", name: "MSC Cruises au"},
                    {value: "8", name: "Norwegian"},
                    {value: "58", name: "Oceania Cruises"},
                    {value: "104", name: "P&amp;O Australia"},
                    {value: "129", name: "Pandaw River"},
                    {value: "2", name: "Princess"},
                    {value: "15", name: "Regent Seven Seas"},
                    {value: "4", name: "Royal Caribbean"},
                    {value: "21", name: "Seabourn"},
                    {value: "17", name: "Silversea"},
                    {value: "40", name: "Star"},
                    {value: "200", name: "Travelmarvel"},
                    {value: "136", name: "Uniworld au"},
                    {value: "130", name: "Viking  au"},
                    {value: "24", name: "Windstar"}
                ];
            },

            hideCruiseOptions: function (model) {
                'use strict';
                return !model.get('showCruiseOptions');
            },

            departurePortOptions: function (model) {
                return [
                    {value: "-99", name: "All Departure Ports", selected: "selected"},
                    {value: "3941", name: "Accra"},
                    {value: "209", name: "Amsterdam"},
                    {value: "71", name: "Anchorage (Seward)"},
                    {value: "2703", name: "Anchorage (Whittier)"},
                    {value: "1174", name: "Arles"},
                    {value: "4037", name: "Athens"},
                    {value: "303", name: "Athens/Piraeus"},
                    {value: "381", name: "Auckland"},
                    {value: "4968", name: "Bali"},
                    {value: "526", name: "Baltimore"},
                    {value: "3026", name: "Baltra Galapagos"},
                    {value: "561", name: "Bangkok"},
                    {value: "124", name: "Barcelona"},
                    {value: "825", name: "Basel"},
                    {value: "560", name: "Beijing"},
                    {value: "2755", name: "Belgrade"},
                    {value: "4260", name: "Benoa"},
                    {value: "371", name: "Benoa Bali"},
                    {value: "193", name: "Bergen"},
                    {value: "83", name: "Boston"},
                    {value: "32", name: "Bridgetown"},
                    {value: "374", name: "Brisbane"},
                    {value: "4440", name: "Broome"},
                    {value: "2752", name: "Bucharest"},
                    {value: "569", name: "Budapest"},
                    {value: "433", name: "Buenos Aires"},
                    {value: "4050", name: "Cairo"},
                    {value: "648", name: "Caldera"},
                    {value: "485", name: "Callao (Lima)"},
                    {value: "3001", name: "Cape Liberty / Bayonne NJ"},
                    {value: "834", name: "Cape Town"},
                    {value: "279", name: "Charleston SC"},
                    {value: "241", name: "Charlotte Amalie St. Thomas"},
                    {value: "5423", name: "Churchill"},
                    {value: "136", name: "Civitavecchia"},
                    {value: "216", name: "Civitavecchia/Rome"},
                    {value: "1198", name: "Cologne"},
                    {value: "130", name: "Colon"},
                    {value: "169", name: "Copenhagen"},
                    {value: "4874", name: "Cote dAzur"},
                    {value: "1058", name: "Cristobal"},
                    {value: "4448", name: "Darwin"},
                    {value: "677", name: "Dubai U.A.E."},
                    {value: "189", name: "Dublin"},
                    {value: "377", name: "Dunedin"},
                    {value: "267", name: "Edinburgh"},
                    {value: "76", name: "Ensenada"},
                    {value: "10", name: "Fort Lauderdale"},
                    {value: "1200", name: "Frankfurt"},
                    {value: "1107", name: "Fremantle"},
                    {value: "133", name: "Funchal Madeira"},
                    {value: "88", name: "Galveston"},
                    {value: "306", name: "Genoa"},
                    {value: "183", name: "Greenock"},
                    {value: "213", name: "Hamburg"},
                    {value: "4255", name: "Hanoi"},
                    {value: "176", name: "Harwich"},
                    {value: "349", name: "Heraklion"},
                    {value: "4713", name: "Ho Chi Minh City (My Tho)"},
                    {value: "1100", name: "Ho Chi Minh City/Saigon"},
                    {value: "538", name: "Hong Kong"},
                    {value: "78", name: "Honolulu"},
                    {value: "693", name: "Houston"},
                    {value: "145", name: "Istanbul"},
                    {value: "1812", name: "Jacksonville"},
                    {value: "4270", name: "Jakarta"},
                    {value: "4678", name: "Kangerlussuaq"},
                    {value: "2710", name: "Kiel"},
                    {value: "638", name: "Kobe"},
                    {value: "1728", name: "La Romana"},
                    {value: "630", name: "Laem Chabang"},
                    {value: "365", name: "Las Palmas"},
                    {value: "1083", name: "Lautoka"},
                    {value: "110", name: "Le Havre"},
                    {value: "700", name: "Lima"},
                    {value: "156", name: "Lisbon"},
                    {value: "3897", name: "London (Dover)"},
                    {value: "5332", name: "London (HMS Belfast)"},
                    {value: "3894", name: "London (Southampton)"},
                    {value: "3959", name: "London (Tower Bridge)"},
                    {value: "736", name: "Longyearbyen"},
                    {value: "4504", name: "Los Angeles"},
                    {value: "1721", name: "Los Angeles (Long Beach)"},
                    {value: "89", name: "Los Angeles (San Pedro)"},
                    {value: "1183", name: "Lyon"},
                    {value: "3159", name: "Madras"},
                    {value: "200", name: "Malaga"},
                    {value: "1106", name: "Manaus"},
                    {value: "4399", name: "Mannum, Sth Aust."},
                    {value: "159", name: "Marseille"},
                    {value: "375", name: "Melbourne"},
                    {value: "153", name: "Messina"},
                    {value: "5", name: "Miami"},
                    {value: "135", name: "Monte Carlo"},
                    {value: "93", name: "Montreal"},
                    {value: "808", name: "Moscow"},
                    {value: "802", name: "Mumbai"},
                    {value: "137", name: "Naples"},
                    {value: "92", name: "New Orleans"},
                    {value: "9", name: "New York"},
                    {value: "227", name: "Nice"},
                    {value: "2871", name: "Nome"},
                    {value: "520", name: "Norfolk"},
                    {value: "1206", name: "Nuremberg"},
                    {value: "39", name: "Oranjestad (Aruba)"},
                    {value: "177", name: "Oslo"},
                    {value: "1086", name: "Otaru"},
                    {value: "363", name: "Papeete"},
                    {value: "1130", name: "Paris"},
                    {value: "1207", name: "Passau"},
                    {value: "1030", name: "Perth"},
                    {value: "27", name: "Philipsburg St. Maarten"},
                    {value: "41", name: "Port Canaveral"},
                    {value: "4601", name: "Port Denarau"},
                    {value: "3093", name: "Port Louis (Mauritius)"},
                    {value: "4991", name: "Portsmouth, UK"},
                    {value: "545", name: "Prague"},
                    {value: "292", name: "Puerto Caldera"},
                    {value: "438", name: "Punta Arenas Chile"},
                    {value: "102", name: "Quebec"},
                    {value: "2949", name: "Quebec City"},
                    {value: "190", name: "Reykjavik"},
                    {value: "442", name: "Rio de Janeiro"},
                    {value: "3960", name: "Rome"},
                    {value: "181", name: "Rotterdam"},
                    {value: "74", name: "San Diego"},
                    {value: "56", name: "San Francisco"},
                    {value: "25", name: "San Juan"},
                    {value: "3303", name: "Santiago/Valparaiso"},
                    {value: "4324", name: "Sao Paulo (Santos)"},
                    {value: "467", name: "Savona"},
                    {value: "75", name: "Seattle"},
                    {value: "398", name: "Seville"},
                    {value: "409", name: "Seward"},
                    {value: "641", name: "Shanghai"},
                    {value: "4716", name: "Siem Reap"},
                    {value: "4528", name: "Siem Reap"},
                    {value: "382", name: "Singapore"},
                    {value: "109", name: "Southampton"},
                    {value: "171", name: "St. Petersburg"},
                    {value: "173", name: "Stockholm"},
                    {value: "383", name: "Sydney"},
                    {value: "84", name: "Tampa Bay"},
                    {value: "654", name: "Tarragona"},
                    {value: "252", name: "Tenerife"},
                    {value: "4378", name: "Tianjin"},
                    {value: "783", name: "Tokyo"},
                    {value: "4431", name: "Tokyo (Yokohama)"},
                    {value: "2767", name: "Toulon"},
                    {value: "2776", name: "Trieste"},
                    {value: "248", name: "Tromso"},
                    {value: "437", name: "Ushuaia"},
                    {value: "440", name: "Valparaiso"},
                    {value: "70", name: "Vancouver"},
                    {value: "146", name: "Venice"},
                    {value: "547", name: "Vienna"},
                    {value: "5000", name: "Vilnius"},
                    {value: "5235", name: "Warnemunde Rostock Germany"},
                    {value: "2356", name: "Whittier"},
                    {value: "4092", name: "Zurich"}
                ];
            },

            sortByOptions: function (model) {
                return [
                    {value: "4", name: "Price", selected: "selected"},
                    {value: "5", name: "Sailing Date"},
                    {value: "2", name: "Cruise Line"},
                    {value: "9", name: "Ship Rating"},
                    {value: "10", name: "Special Offer"}
                ];
            },

            sortOrderOptions: function (model) {
                return [
                    {value: "1", name: "Ascending", selected: "selected"},
                    {value: "2", name: "Decending"}
                ];
            },

            priceRangeOptions: function (model) {
                return [
                    {value: "-99", name: "All Prices", selected: "selected"},
                    {value: "1", name: "Under $250"},
                    {value: "2", name: "$250 - $499"},
                    {value: "3", name: "$500 - $999"},
                    {value: "4", name: "$1000 - $1499"},
                    {value: "5", name: "Over $1500"}
                ];
            }
        }
    };

    cruiseConfig.viewRules.sailingDateOptions= function (model) {
        var sailingDates = [
            {name: "Any Date", value: "", selected: "selected"}
        ];
        var currentDate = new Date();
        var month = currentDate.getMonth();
        var year = currentDate.getFullYear();
        for (var i = 0; i < 23; i++) {
            var optionName = cruiseConfig.calendar.months[month] + year.toString();
            month = month + 1;
            var optionValue = month.toString() + 'X' + year.toString();
            sailingDates = sailingDates.concat({name: optionName, value: optionValue});
            year = month > 11 ? year + 1 : year;
            month = month > 11 ? 0 : month;
        }
        return sailingDates;
    };

    cruiseConfig.getShips = function (cruiseLine, state) {
        var items = [
            {name: "All Ships", value: "-99"}
        ];
        if (cruiseLineShipMaps[cruiseLine] != undefined) {
            items = cruiseLineShipMaps[cruiseLine];
        }
        state.set('shipOptions', items);
    };

    cruiseConfig.cruiseLineChange = function (state) {
        var tab = getLob(state.get('tab'), state.get('packages'));
        if (tab == 'cruise') {
            var cruiseLine = state.get('cruise-line');
            cruiseConfig.getShips(cruiseLine, state);
        }
    };

    defaultConfig.addEvent('cruise-line', cruiseConfig.cruiseLineChange);
    defaultConfig.addEvent('shipOptions', 'reloadWizard');

    return cruiseConfig;

});

define('gc/flightCarConfigOverride', function() {
  return {};
});
define('gc/flightConfigOverride', function() {
  return {};
});
define('gc/hotelCarConfigOverride', function() {
  return {};
});

define('gc/threePPConfigOverride', function() {
    return {};
});
define('gc/vacationRentalsConfigOverride', function() {
    return {};
});
define('gc/openSearchConfigOverride', function() {
    return {};
});
define('gc/confOverride', function() {
		return {};
});
define('gc/carSearchUrlOverride', function() {
    return {};
});
define('gc/cruiseSearchUrlOverride', ['gc/SearchUrl'], function(SearchUrl) {
    var cruiseSearchUrl = {
        searchUrlGenerator: function (model) {
            var url = new SearchUrl('http://cruise.expedia.com.au/cruises/cruisedefault2.jsp');
            url.beginQuery();

            url.addParameter('destination', model['cruise-destination'], true);
            url.addParameter('date', model['sailing-date'], true);
            url.addParameter('dur', model.duration, true);
            url.addParameter('cruiseline', model['cruise-line'], true);
            url.addParameter('cobrand', model.cobrand, true);
            url.addParameter('webpagerecno', model.webpagerecno, true);
            url.addParameter('dport', model['departure-port'], true);
            if (model.showCruiseOptions) {
                url.addParameter('as', 1, true);
                url.addParameter('specid', model.sailingID, true);
                url.addParameter('ship', model.ship, true);
                url.addParameter('sort', model['sort-by'], true);
                url.addParameter('ord', model['sort-order'], true);
                url.addParameter('prange', model['price-range'], true);
            } else {
                url.addParameter('bs', 1, true);
            }
            return url.toString();
        }
    };

    return cruiseSearchUrl;
});
define('gc/threePPSearchUrlOverride', function() {
    return {};
});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/includes/bpg", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "    <a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.bpgModel : depth0)) != null ? stack1.url : stack1), depth0))
    + "\" class=\"wizard-bpg-logo bpg-val-prop cf\" data-show-for=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.bpgModel : depth0)) != null ? stack1.showFor : stack1), depth0))
    + "\">\n        "
    + ((stack1 = (helpers['uitk-icon'] || (depth0 && depth0['uitk-icon']) || helpers.helperMissing).call(depth0,{"name":"uitk-icon","hash":{"name":"success"},"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.bpgModel : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n    </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showBPG : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/layouts/wizard-hbs-threepp", Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<section class=\"tab-pane on\" id=\"tab-threePP\">\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n    </div>\n</section>";
},"useData":true}));});
require('handlebars.runtime', function(Handlebars) { Handlebars.registerPartial("corewizard/field-groups/cruise-hbs", Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"destination",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['cruise-destination'] : depth0),"options-list":(depth0 != null ? depth0.destinationOptions : depth0),"wizard-action":"{\"cruise-destination\" : \"$value1\"}","label-text":"Destination"},"data":data}))
    + "\n\n        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"sailing-date",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['sailing-date'] : depth0),"options-list":(depth0 != null ? depth0.sailingDateOptions : depth0),"wizard-action":"{\"sailing-date\" : \"$value1\"}","label-text":"Sailing Date"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"duration",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.duration : depth0),"options-list":(depth0 != null ? depth0.durationOptions : depth0),"wizard-action":"{\"duration\" : \"$value1\"}","label-text":"Duration"},"data":data}))
    + "\n\n        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"departure-port",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['departure-port'] : depth0),"options-list":(depth0 != null ? depth0.departurePortOptions : depth0),"wizard-action":"{\"departure-port\" : \"$value1\"}","label-text":"Departure Port"},"data":data}))
    + "\n";
},"5":function(depth0,helpers,partials,data) {
    return "        "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"line",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['cruise-line'] : depth0),"options-list":(depth0 != null ? depth0.cruiseLineOptions : depth0),"wizard-action":"{\"cruise-line\" : \"$value1\"}","label-text":"Cruise Line"},"data":data}))
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    return "viewed";
},"9":function(depth0,helpers,partials,data) {
    return "open";
},"11":function(depth0,helpers,partials,data) {
    return "true";
},"13":function(depth0,helpers,partials,data) {
    return "false";
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "        <div id=\"advanced-options-fields\">\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"destination-only cols-nested"},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            <fieldset>\n                <span class=\"label\">Note: When searching by Sailing ID no other search parameters may be used</span>\n            </fieldset>\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination ship-departure-port"},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination ship-departure-port"},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n        ";
},"16":function(depth0,helpers,partials,data) {
    return "                <label class=\"text col\" id=\"cruise-sailing-id-label\" >\n                    <span class=\"label\">Sailing ID (quick search)</span>\n                    <input\n                            type=\"text\"\n                            id=\"cruise-sailing-id\"\n                            data-wizard-action='{\"sailingID\" : \"$value1\"}'\n                            ia-value=sailingID\n                            />\n                </label>\n";
},"18":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"ship",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.ship : depth0),"options-list":(depth0 != null ? depth0.shipOptions : depth0),"wizard-action":"{\"ship\" : \"$value1\"}","label-text":"Ship"},"data":data}))
    + "\n\n                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"sort-by",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['sort-by'] : depth0),"options-list":(depth0 != null ? depth0.sortByOptions : depth0),"wizard-action":"{\"sort-by\" : \"$value1\"}","label-text":"Sort By","class":""},"data":data}))
    + "\n";
},"20":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"sort-order",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['sort-order'] : depth0),"options-list":(depth0 != null ? depth0.sortOrderOptions : depth0),"wizard-action":"{\"sort-order\" : \"$value1\"}","label-text":"Sort Order","class":""},"data":data}))
    + "\n\n                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"price-range",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['price-range'] : depth0),"options-list":(depth0 != null ? depth0.priceRangeOptions : depth0),"wizard-action":"{\"price-range\" : \"$value1\"}","label-text":"Price Range","class":""},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<section class=\"tab-cruise tab-pane on\" id=\"tab-cruise\" data-tid=\"wizard-cruises\">\n<div id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination fix-margin-top"},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination fix-margin-top"},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    <section class=\"advanced-options\">\n        <a  href=\"#advanced-options-fields\"\n            role=\"button\"\n            id=\"advanced-options\"\n            aria-controls=\"advanced-options-fields\"\n            class=\"toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            data-wizard-action='{\"showCruiseOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'>\n                "
    + alias2(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n        </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    </section>\n</div>\n</section>";
},"useData":true}));});
this["Handlebars"] = this["Handlebars"] || {};
this["Handlebars"]["templates"] = this["Handlebars"]["templates"] || {};
this["Handlebars"]["templates"]["bpg"] = {"1":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda, alias2=this.escapeExpression;

  return "    <a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.bpgModel : depth0)) != null ? stack1.url : stack1), depth0))
    + "\" class=\"wizard-bpg-logo bpg-val-prop cf\" data-show-for=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.bpgModel : depth0)) != null ? stack1.showFor : stack1), depth0))
    + "\">\n        "
    + ((stack1 = (helpers['uitk-icon'] || (depth0 && depth0['uitk-icon']) || helpers.helperMissing).call(depth0,{"name":"uitk-icon","hash":{"name":"success"},"data":data})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.bpgModel : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n    </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showBPG : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true};
this["Handlebars"]["templates"]["wizard-hbs-threepp"] = {"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<section class=\"tab-pane on\" id=\"tab-threePP\">\n    <div id=\""
    + this.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n\n    </div>\n</section>";
},"useData":true};
this["Handlebars"]["templates"]["cruise-hbs"] = {"1":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"destination",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['cruise-destination'] : depth0),"options-list":(depth0 != null ? depth0.destinationOptions : depth0),"wizard-action":"{\"cruise-destination\" : \"$value1\"}","label-text":"Destination"},"data":data}))
    + "\n\n        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"sailing-date",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['sailing-date'] : depth0),"options-list":(depth0 != null ? depth0.sailingDateOptions : depth0),"wizard-action":"{\"sailing-date\" : \"$value1\"}","label-text":"Sailing Date"},"data":data}))
    + "\n";
},"3":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"duration",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.duration : depth0),"options-list":(depth0 != null ? depth0.durationOptions : depth0),"wizard-action":"{\"duration\" : \"$value1\"}","label-text":"Duration"},"data":data}))
    + "\n\n        "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"departure-port",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['departure-port'] : depth0),"options-list":(depth0 != null ? depth0.departurePortOptions : depth0),"wizard-action":"{\"departure-port\" : \"$value1\"}","label-text":"Departure Port"},"data":data}))
    + "\n";
},"5":function(depth0,helpers,partials,data) {
    return "        "
    + this.escapeExpression((helpers.select || (depth0 && depth0.select) || helpers.helperMissing).call(depth0,depth0,"line",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['cruise-line'] : depth0),"options-list":(depth0 != null ? depth0.cruiseLineOptions : depth0),"wizard-action":"{\"cruise-line\" : \"$value1\"}","label-text":"Cruise Line"},"data":data}))
    + "\n";
},"7":function(depth0,helpers,partials,data) {
    return "viewed";
},"9":function(depth0,helpers,partials,data) {
    return "open";
},"11":function(depth0,helpers,partials,data) {
    return "true";
},"13":function(depth0,helpers,partials,data) {
    return "false";
},"15":function(depth0,helpers,partials,data) {
    var stack1, alias1=helpers.helperMissing;

  return "        <div id=\"advanced-options-fields\">\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"destination-only cols-nested"},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "            <fieldset>\n                <span class=\"label\">Note: When searching by Sailing ID no other search parameters may be used</span>\n            </fieldset>\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination ship-departure-port"},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination ship-departure-port"},"fn":this.program(20, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n        ";
},"16":function(depth0,helpers,partials,data) {
    return "                <label class=\"text col\" id=\"cruise-sailing-id-label\" >\n                    <span class=\"label\">Sailing ID (quick search)</span>\n                    <input\n                            type=\"text\"\n                            id=\"cruise-sailing-id\"\n                            data-wizard-action='{\"sailingID\" : \"$value1\"}'\n                            ia-value=sailingID\n                            />\n                </label>\n";
},"18":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"ship",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0.ship : depth0),"options-list":(depth0 != null ? depth0.shipOptions : depth0),"wizard-action":"{\"ship\" : \"$value1\"}","label-text":"Ship"},"data":data}))
    + "\n\n                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"sort-by",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['sort-by'] : depth0),"options-list":(depth0 != null ? depth0.sortByOptions : depth0),"wizard-action":"{\"sort-by\" : \"$value1\"}","label-text":"Sort By","class":""},"data":data}))
    + "\n";
},"20":function(depth0,helpers,partials,data) {
    var alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"sort-order",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['sort-order'] : depth0),"options-list":(depth0 != null ? depth0.sortOrderOptions : depth0),"wizard-action":"{\"sort-order\" : \"$value1\"}","label-text":"Sort Order","class":""},"data":data}))
    + "\n\n                "
    + alias2((helpers.select || (depth0 && depth0.select) || alias1).call(depth0,depth0,"price-range",{"name":"select","hash":{"ia-data-select-value":(depth0 != null ? depth0['price-range'] : depth0),"options-list":(depth0 != null ? depth0.priceRangeOptions : depth0),"wizard-action":"{\"price-range\" : \"$value1\"}","label-text":"Price Range","class":""},"data":data}))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2=this.escapeExpression;

  return "<section class=\"tab-cruise tab-pane on\" id=\"tab-cruise\" data-tid=\"wizard-cruises\">\n<div id=\""
    + alias2(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias1),(typeof helper === "function" ? helper.call(depth0,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination fix-margin-top"},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.row || (depth0 && depth0.row) || alias1).call(depth0,{"name":"row","hash":{"class":"origin-destination fix-margin-top"},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    <section class=\"advanced-options\">\n        <a  href=\"#advanced-options-fields\"\n            role=\"button\"\n            id=\"advanced-options\"\n            aria-controls=\"advanced-options-fields\"\n            class=\"toggle-trigger "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            data-wizard-action='{\"showCruiseOptions\" : "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hideCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " }'>\n                "
    + alias2(this.lambda(((stack1 = (depth0 != null ? depth0.loc : depth0)) != null ? stack1.advancedOptionsLabel : stack1), depth0))
    + "<span class=\"icon icon-expand\"></span>\n        </a>\n\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showCruiseOptions : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    </section>\n</div>\n</section>";
},"useData":true};
define('gc/loc', ['jquery', 'gc/locOverride'], function($, locOverride) { loc = {"flightRoundtripLabel":"Return","flightOnewayLabel":"One way","flightMultidestLabel":"Multiple destinations","flightDestinationLabel":"Flying to <span class='visuallyhidden'>city or airport</span>","flightPlaceholderText":"City or airport","flightOriginLabel":"Flying from <span class='visuallyhidden'>city or airport</span>","flightDepartingLabel":"Departing <span class='visuallyhidden'>date, in MM/DD/YYYY format</span>","flightReturningLabel":"Returning <span class='visuallyhidden'>date, in MM/DD/YYYY format</span>","advancedOptionsLabel":"Advanced options","addHotelLinkText":"Add a hotel","addCarLinkText":"Add a car","addFlightLinkText":"Add a flight","hotelDestinationLabel":"Going to <span class='visuallyhidden'>city or airport</span>","hotelDestinationPlaceholderText":"City, airport, landmark, or address","hotelCheckinLabel":"Check-in <span class='visuallyhidden'>date, in DD/MM/YYYY format</span>","hotelCheckoutLabel":"Check-out <span class='visuallyhidden'>date, in DD/MM/YYYY format</span>","hotelTabletValueProp":"Over {{package_search_over_hotel_count}} Hotels worldwide","carPickupDateLabel":"Pick-up date","carPickupTimeLabel":"Pick up time","carDropoffDateLabel":"Drop-off date","carDropOffTimeLabel":"Drop off time","carPickupLabel":"Pick-up <span class='visuallyhidden'>City, airport or address</span>","carPickupPlaceholder":"City, airport or address","carDropoffLabel":"Drop-off","carDropoffPlaceholder":"Same as pick-up","carShowOptionsLabel":"Advanced options","carSpecialEquipment":"Special equipment","carDiscountEnterCodeLabel":"Enter Code","activityDestinationLabel":"Destination","activityDestinationPlaceholder":"City","startDateLabel":"From <span class='visuallyhidden'>date, in DD/MM/YYYY format</span>","endDateLabel":"To <span class='visuallyhidden'>date, in DD/MM/YYYY format</span>","partialStayLabel":"I only need a hotel for part of my stay","flightRefundableLabel":"Refundable flight","flightNonStopLabel":"Direct","perferredAirlineLabel":"Preferred airline","perferredClassLabel":"Preferred class","preferredClassFirst":"First Class","preferredClassBusiness":"Business","preferredClassEconomy":"Economy","preferredClassPremiumEconomy":"Premium Economy","preferredAirlineDefault":"No Preference","flightLabel":"Flight","childLabel":"Child {{childIndex}} age","directFlightLabel":"Direct flights only","errorMessageTitle":"Please correct the errors below.","originErrorMessageText":"Please complete the highlighted origin field below.","destinationErrorMessageText":"Please complete the highlighted destination field below.","originAndDestinationSameMessageText":"Please choose a different destination from origin.","dateBlankMessageText":"Please complete the highlighted date field(s) below.","startDateBlankMessageText":"Please complete the highlighted departing date field(s) below.","endDateBlankMessageText":"Please complete the highlighted returning date field(s) below.","dateFormatInvalidMessageText":"Date format should be {{dateFormat}}.","dateRangeTooLongErrorMessageText":"Your length of stay cannot be longer than {{maxTripLength}} nights.","dateOutOfRangeMessageText":"We can only accept dates that occur between {{minCalendarDate}} and {{maxCalendarDate}}. Please enter a new date.","dateBeforeCurrentDateMessageText":"The start or end date is prior to the current date.,","dateTimeRangeMessageText":"The drop-off date and time must occur at least two hours after the pick-up date and time.","partialStayDatesOutOfRangeText":"Your partial check-in and check-out dates must fall within your arrival and departure dates. Please review your dates.","multiDestDateErrorText":"The departing dates must occur after the previous departing date. Please correct the departing date(s).","numberOfTravellersMessageText":"We are only able to book between 1 and 6 travellers. Please adjust the number of travellers for your search.","childAgeMessageText":"Please provide the ages of children below.","ageHelpMessage":"Please indicate age of child at return date","airlineAgeRules":"Airline age rules","flightDontNeed":"I don't need a flight","flightChildInLapLabel":"In Lap","flightTypeHelpToolTipText":"Information about packages","flightTypeHelpMessage":"You can only book a package with a roundtrip flight.","hotelDontNeed":"I don't need a hotel","flightChildNote":"Children under 2 must either sit in laps or in seats.","flightChildInSeatLabel":"In Seat","carDontNeedLabel":"I don't need a car","carWillBeAddedLabel":"An economy car will be added to your search. (You may change your car options later.)","hotelCarDestinationLabel":"Going to","hotelCarDestinationPlaceholder":"city, airport, landmark, or address","hotelRoomLabel":"Room ###number###","hotelRoomsCountLabel":"Rooms","fhMessage1":"Save up to $570","fhMessage2":"Book Flight + Hotel at the same time*","nonfhMessage":"Book together and SAVE!","flightHotelMessage":"You can only book 3 rooms or fewer with a Hotel + Flight package","hotelCarMessage":"You can only book 3 rooms or fewer with a Hotel + Car package","searchForATrip":"Search for a Trip","travelWithExpedia":"Travel with Expedia","flightAdultsLabel":"Adults (18+)","flightChildrenLabel":"Children (0-17)","childAgesLabel":"Child","childAgesDefault":"Age","childUnder1":"Under 1","hotelPreFilledOptions2Adults":"2 adults, 0 children","hotelPreFilledOptions1Adult":"1 adult, 0 children","hotelPreFilledOptionsMoreOptions":"More options","guestsLabel":"<span class=\"visuallyhidden\">Number of</span> Guests","tabLoc":{"flight":"Flights","hotel":"Hotels","flightPLabel":"Flight","hotelPLabel":"Hotel","carPLabel":"Car","car":"Cars","package":"<span class='desktop-only'>Package Deals</span><span class='tablet-only'>Flight + Hotel</span>","flightHotel":"Flight + Hotel","flightCar":"Flight + Car","flightHotelCar":"Flight + Hotel + Car","rentalCars":"Rental Cars","airportRides":"Airport Rides","lxThingsTodo":"Things to Do","lxAirportRides":"Airport Rides","hotelCar":"Hotel + Car","trainHotel":"Eurostar + Hotel","cruise":"Cruises","activity":"Things to Do","threePP":"Holidays","hotelPlusFlight":"Hotel + Flight","hotelPlusFlightPlusCar":"Hotel + Flight + Car","hotelPlusCar":"Hotel + Car","carPlusHotel":"Car + Hotel","carPlusHotelPlusFlight":"Car + Hotel + Flight","carPlusFlight":"Car + Flight","flightPlusHotel":"Flight + Hotel","flightPlusHotelPlusCar":"Flight + Hotel + Car","flightPlusCar":"Flight + Car","vacationRentals":"Holiday Rentals"},"formTitle":{"flightHotel":"Search Vacation Packages","flightHotelCar":"Search Vacation Packages","flightCar":"Search Vacation Packages","hotelCar":"Search Vacation Packages","flight":"Search Flights","hotel":"Search Hotels","car":"Search Cars","activity":"Search Things To Do","cruise":"Search Cruises"},"hotelDestination":{"label":"Going to","placeholderText":"City, airport, landmarks or address"},"flight":{"locationPlaceholder":"City or airport"},"carOptionsLoc":{"carType":"Car type","carVendor":"Car hire company","carDiscountCode":"Discount code","carNoCode":"I don't have a code","carCorporateContracted":"Corporate or contracted","carSpecialAdvertised":"Special or advertised","carSpecialEquipmentLabel":"Special Equipment","carSpecialEquipment":"Special Equipment","carInfantseat":"Infant seat","carToddlerseat":"Toddler seat","carNavigation":"Navigation system","carSkirack":"Ski rack","carChains":"Snow chains","carLefthand":"Left hand control","carRighthand":"Right hand control","rateCode":"Discount Rate Code","couponCode":"Discount Coupon Code","corpDiscount":"Corporate Discount Code","carRentalCompanyNoPreference":"No Preference","carRentalCompanySelectFromList":"Select from the list","timeValue0000":"12:00AM","timeValue0030":"12:30AM","timeValue0100":"1:00AM","timeValue0130":"1:30AM","timeValue0200":"2:00AM","timeValue0230":"2:30AM","timeValue0300":"3:00AM","timeValue0330":"3:30AM","timeValue0400":"4:00AM","timeValue0430":"4:30AM","timeValue0500":"5:00AM","timeValue0530":"5:30AM","timeValue0600":"6:00AM","timeValue0630":"6:30AM","timeValue0700":"7:00AM","timeValue0730":"7:30AM","timeValue0800":"8:00AM","timeValue0830":"8:30AM","timeValue0900":"9:00AM","timeValue0930":"9:30AM","timeValue1000":"10:00AM","timeValue1030":"10:30AM","timeValue1100":"11:00AM","timeValue1130":"11:30AM","timeValue1200":"12:00PM","timeValue1230":"12:30PM","timeValue1300":"1:00PM","timeValue1330":"1:30PM","timeValue1400":"2:00PM","timeValue1430":"2:30PM","timeValue1500":"3:00PM","timeValue1530":"3:30PM","timeValue1600":"4:00PM","timeValue1630":"4:30PM","timeValue1700":"5:00PM","timeValue1730":"5:30PM","timeValue1800":"6:00PM","timeValue1830":"6:30PM","timeValue1900":"7:00PM","timeValue1930":"7:30PM","timeValue2000":"8:00PM","timeValue2030":"8:30PM","timeValue2100":"9:00PM","timeValue2130":"9:30PM","timeValue2200":"10:00PM","timeValue2230":"10:30PM","timeValue2300":"11:00PM","timeValue2330":"11:30PM","typeNoPref":"No Preference","typeEconomy":"Economy","typeCompact":"Compact","typeMidsize":"Midsize","typeStandard":"Standard","typeFullsize":"Fullsize","typePremium":"Premium","typeLuxury":"Luxury","typeConvertible":"Convertible","typeMinivan":"Minivan","typeSportUtilityVehicle":"Sport Utility Vehicles","typeSports":"Sports car","vendorAce":"ACE Rent A Car","vendorAdvantage":"Advantage Rent-A-Car","vendorAlamo":"Alamo Rent A Car","vendorAvis":"Avis","vendorBudget":"Budget","vendorDollar":"Dollar Rent A Car","vendorEconomy":"Economy Rent a Car","vendorEnterprise":"Enterprise","vendorEuropcar":"Europcar","vendorFox":"Fox Rental Cars","vendorHertz":"Hertz","vendorMidway":"Midway Car Hire","vendorNational":"National Car Hire","vendorNu":"Nü Car","vendorPayless":"Payless","vendorSixt":"Sixt","vendorThrifty":"Thrifty Car Rental","vendorUSave":"U-Save"},"typeAhead":{"closetext":"Close","continuetext":"Continue typing to see results","region":"Region","attractions":"Attractions","airports":"Airports","hotels":"Hotels","flights":"Flights","packages":"Packages","cars":"Cars","cruises":"Cruises","activities":"Activities","hotelName":"Hotel Name","address":"Address","trains":"Trains","metros":"Metros","rentals":"Rental Locations","deals":"Deals","postcode":"Postal Code","cheapHotelsText":"Cheap hotels","bestDealsText":"Best deals","recent":"Recent","trending":"Trending searches near you"},"searchButtonText":{"defaultText":"Search","hotelFlightText":"Search Hotel + Flight","hotelFlightCarText":"Search Hotel + Flight + Car","hotelCarText":"Search Hotel + Car","hotel9Plus":"Request 9+ Hotel Rooms"},"threePP":{"10Plus":"Book for 10+ people","departing":"Departing","destination":"Going to","duration":"Duration","featuresAllInclusive":"All-inclusive","featuresBeachFront":"Beachfront","featuresGolfCourse":"Golf Course","featuresKitchenette":"Kitchenette","featuresTitle":"Features","hotelQuality":"Hotel class","hotelSelect":"Hotels","origin":"Leaving from","priceNoPreference":"No Preference","priceTitle":"Price range per person","priceUnder1k":"Under C$1,000","priceUnder1k5":"Under C$1,500","priceUnder2k":"Under C$2,000","title":"Search Vacations","hotelSelectLabel":"All hotels","hotelQualityLabel":"3 stars or more","qualityAll":"All Ratings","quality2Stars":"2 stars or more","quality3Stars":"3 stars or more","quality4Stars":"4 stars or more","quality5Stars":"5 stars","threeToFour":"3 or 4 days","fiveToTen":"5 to 10 days","elevenToSixteen":"11 to 16 days","seventeenPlus":"17 days or more","nights":"nights","days":"days"},"cruise":{"destinationLabel":"Going to","departureMonthLabel":"Departure month","otherDestinationsLabel":"Other Destinations","selectDestinationLabel":"Select destination","selectDateLabel":"Select date","showAll":"Show all","mostPopular":"Most Popular","optionCaribbean":"Caribbean","optionBahamas":"Bahamas","optionMexico":"Mexico","optionAlaska":"Alaska","optionEurope":"Europe","optionBermuda":"Bermuda","optionHawaii":"Hawaii","optionCanadaNE":"Canada / New England","optionAfrica":"Africa","optionArcticAntarctic":"Arctic / Antarctic","optionAsia":"Asia","optionAustraliaNZ":"Australia / New Zealand","optionCentralAmerica":"Central America","optionNowhere":"Cruise To Nowhere","optionGalapagos":"Galapagos","optionGreenlandIceland":"Greenland / Iceland","optionMiddleEast":"Middle East","optionPacificCoastal":"Pacific Coastal","optionPanamaCanal":"Panama Canal","optionSouthAmerica":"South America","optionSouthPacific":"South Pacific","optionTahiti":"Tahiti","optionTransatlantic":"Transatlantic","optionWorldCruises":"World Cruises","optionRepositioning":"Repositioning","cruiseLine":"Cruise line","cruiseDeparturePort":"Departure port","cruiseLength":"Cruise length"},"calendar":{"dateFormat":"ddmmyy","dateSeparator":"/","startDayOfTheWeek":"1","singleMonths":"JAN,FEV,MAR,APR,MAY,JUN,JUL,AUG,SEP,OCT,NOV,DEC","months":"January,February,March,April,May,June,July,August,September,October,November,December","shortMonths":"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec","daysOfTheWeek":"S,M,T,W,T,F,S","dayNames":"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday","shortDays":"Sun,#Mon,#Tue,#Wed,#Thu,#Fri,#Sat,","dateFormatWithSeparator":"dd/MM/yyyy","userVisibleDateFormat":"dd/mm/yyyy","closeLink":"Close","nightsTexts":"one night,nights,1 night trip,# night trip"},"masterconfig":{"package_search_over_hotel_count":"271,000","packageOrder":"fh,fhc,fc,hc","carsTaCategories":{},"abacus":{},"switches":{"useBestPriceGuaranteeLogo":true,"enableCarOffairportOnewaySearch":true}}}; $.extend(true, loc, locOverride); return loc; });